module.exports = __webpack_public_path__ + "img/locker_is_full.2f84cd97.svg";